import { createClient } from '@/shared/api';
import AI_EVENT_STRIPS_QUERY from '@/entities/strip/api/queries/aiEventStrips';

export type AiEventStrip = {
  id: string;
  isSelected: boolean;
  images: string[];
  draw: any;
  start: string;
  stop: string;
  comment: string;
  userUpdated: boolean;
};

export type AiEventStripsEvent = {
  id: string;
  start: string;
  stop: string;
  type: string;
  technicianComments: string;
  comment: string;
  minHr: number;
  maxHr: number;
  isIncludedToReport: boolean;
  channel: number;
  title: string;
  strips: AiEventStrip[];
};

export type AiEventStripsResult = {
  isSuccess: boolean;
  message: string;
  events: AiEventStripsEvent[];
};

// TODO(ts): typed as the HolterEventsFilter GraphQL input once its server-side shape is documented
/**
 * Loads AI-detected events together with their strips for the events tab. Creates an Apollo client honoring the cache flag, runs the holterEvents query with the filter and limit, and returns the events on success or throws the server message.
 *
 * @param filter - Server-side filter for the events.
 * @param limit - Maximum number of events to fetch; defaults to 10.
 * @param isUsingCache - Whether the Apollo client should serve from cache.
 * @returns A promise resolving to the matching holter events.
 */
const fetchAiEventStrips = async (filter: any, limit = 10, isUsingCache?: boolean) => {
  const client = await createClient(isUsingCache);
  const result = await client.query<{ holterEvents: AiEventStripsResult }>({
    query: AI_EVENT_STRIPS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data } = result;
  const { holterEvents } = data;
  if (holterEvents.isSuccess) {
    return holterEvents.events;
  }
  throw new Error(holterEvents.message);
};

export default fetchAiEventStrips;
